export default __webpack_public_path__ + "static/media/Sidebar-icon.806e1b04.svg";